var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"command-cat"}},[(_vm.file)?_c(_vm.file,{tag:"component"}):_c('p',[_c('span',{staticClass:"magneta"},[_vm._v(_vm._s(_vm.input))]),_vm._v(": No such file\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }